import { Label } from "@omni/ui/components/Product/Label/label";
import { cn } from "@omni/utils/styles";

import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const ProductLabelContainer = () => {
    const { t } = useGranite();

    const { discountPercentage } = useECommerceProduct();

    return (
        <Label
            position={"left"}
            type={"label"}
            className={cn("tw:uppercase")}
        >
            <Label.Entry>{t("promotionLabel.promo")}</Label.Entry>
            <Label.Entry variant="secondary">{discountPercentage}%</Label.Entry>
        </Label>
    );
};

export { ProductLabelContainer };
